var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-box"},[_c('div',{staticClass:"connect"},[_c('div',{staticClass:"contact-us"},[_vm._v("聯繫我們")]),_c('p',[_vm._v("電話：00852-39622878")]),_c('p',[_vm._v("郵箱：ccc@firestorm-techhk.com")]),_c('p',[_vm._v("地址：Room A1,11/F Winner Building,36 Man Yue Street,Hung Hom，KL")])])])])
}]

export { render, staticRenderFns }